<template>
    <div>

        <div class="w3-row" v-bind:class="cls0" >
            <div class="w3-col w3-half">
                <content-header v-bind:title="$t(ftitle)"></content-header>
            </div>
            <div class="w3-col w3-quarter w3-right flow-content-actions-header flow-margin-bottom">
                <div class="flow-padding-top w3-large">
                        <span class="fa fa-stack w3-large cursor-pointer w3-right flow-form-action active w3-ripple flow-blue-color w3-margin-right"
                              @click="openNewPatient"
                              :title="$t('addNewPatient')">
                            <i class="fa fa-stack-2x fa-circle  w3-text-white"></i>
                            <i class="fa fa-stack-1x fa-plus fa-inverse flow-blue-color w3-xlarge"></i>
                        </span>
                </div>
            </div>
        </div>

        <!-- CONTENT START -->
        <new-patient-main-card v-if="openNewPatientCard" :onClose="() => {openNewPatientCard = false;}"></new-patient-main-card>

        <!-- MAIN CONTENT CARD START AKA LEFT CONTENT-->

        <div class="w3-container"  v-bind:class="cls1" v-if="!openNewPatientCard">

            <!--Search results-->
        <div class="w3-margin-bottom" v-bind:class="cls2">
            <form class="flow-form-cum-panel" v-bind:class="{'w3-display-middle' : !showTable, 'w-50pc' : !showTable}">
                <div class="flow-margin-bottom">
                    <input class="w3-input flow-form-inline-input zero-left flow-box-shadow w3-padding w-80pc" type="search"
                           :placeholder="$t('searchPlaceholder')"
                           v-model="searchValue"
                           v-bind:class="{'error' : searchError}">

                    <button class="flow-btn w3-btn w3-round w3-border w3-right w3-large flow-blue-bg-color w-20pc w3-padding"
                            @click.prevent="searchPatients" :title="$t('search')">
                        <i class="fa fa-search w3-text-white"></i>
                        <span class="font-weight-bold w3-text-white w3-large w3-padding">{{$t('search')}}</span>
                    </button>
                </div>
                <div v-if="searchError" class="w3-text-red w3-left w-100pc w3-left-align flow-margin-top"> {{$t('searchError')}} </div>
            </form>
        </div>

        <div class="flow-card blue-top w3-padding" v-bind:class="cls2" v-if="showTable && !searchError">

            <loading v-bind:dspin="displayLoading"></loading>

            <div v-if="patients.length === 0">
                <span class="w3-center flow-blue-color">
                    <b class="font-size-1pt25em">{{$t("noPatients")}}</b> <br>
                    <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-margin-top w3-large"
                            @click.prevent="openNewPatientCard = true">
                        <i class="fa fa-plus flow-green-active-color">
                            <span><b class="flow-margin-left w3-text-gray">Add new patient</b></span>
                        </i>
                    </button>
                </span>
            </div>
            <div v-else>
                <table class="w3-table w3-bordered flow-table w3-animate-opacity" v-if="!displayLoading">
                    <thead class="">
                    <th>{{ $t("name") }}</th>
                    <th>
                        {{ $t("patientID") }}
                    </th>
                    <th v-if="!isCardOpen">
                        {{ $t("dob") }}
                    </th>
                    <th>{{ $t("location") }}</th>
                    <th>{{ $t("tag") }}</th>
                    </thead>
                    <tbody>
                    <tr v-for="patient in patients"
                        v-bind:class="patient.id === selectedPatient.id ? 'active' : ''">
                        <td class="primary" @click="patientSelected(patient)">
                            <span v-if="isCardOpen"  v-bind:title="patient.name">{{ trim(patient.name) }}</span>
                            <span v-else>{{patient.name}}</span>

                            <span v-if="loggedIn(patient)">
                                <i class="fa fa-mobile-alt flow-margin-right flow-green-active-color flow-padding-left" :title="$t('loggedIn')"></i>
                            </span>
                        </td>

                        <td>
                            <span v-if="patient.internalIds && patient.internalIds.length > 0">
                                {{ patient.internalIds.join(", ")}}
                            </span>
                        </td>
                        <td v-if="!isCardOpen">
                            <span v-show="patient.dob">{{ patient.dob}}</span>
                        </td>

                        <td v-if="patient.lastSeen.position">
                            {{ patient.lastSeen.position.displayName }}
                        </td>
                        <td v-else></td>

                        <td>
                            {{ patient.ticket }}
                        </td>

                        <td v-if="isCurrentUserAllowedToPrint()"
                            @click="patientToPrintSelected(patient)">
                            <i class="fa fa-print flow-blue-color fa-lg cursor-pointer" :title="$t('print')"></i>
                        </td>

                        <td v-if="!isCardOpen">
                            <router-link
                                    class="fa fa-external-link-alt flow-blue-color"
                                    target="_blank"
                                    :to="{ name: 'patient', params: { id: patient.id }}"
                                    :title="$t('goToPatientDetail')">
                            </router-link>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

            <!--RIGHT CONTENT STARTS HERE = PATIENT INFO + NEW PATIENT -->
            <div v-if="openPatientCard"
                 class="w3-col content-sidebar-right top-from-header w3-animate-right">
                <patient-side-card :selectedPatient="selectedPatient"
                                   :selected-patient-status="selectedPatientStatus"
                                   :selected-patient-device="selectedPatientDevice"
                                   :onClose="() => {openPatientCard = false;}"></patient-side-card>
            </div>

            <div v-else-if="openPrintCard"
                 class="w3-col content-sidebar-right top-from-header w3-animate-right">
                <print-patient-side-card
                        :selectedPatient="selectedPatient"
                        :onClose="() => {openPrintCard = false;}">
                </print-patient-side-card>
            </div>

        </div>


    </div>
</template>
<script>
    import Vue from 'vue';
    import ContentHeader from "../components/common/ContentHeader";
    import Loading from "../components/common/Loading";
    import NewPatientMainCard from "../components/patient/NewPatientMainCard";
    import PatientSideCard from "../components/patient/PatientSideCard";
    import { EventBus } from "../main";
    import PrintPatientSideCard from "../components/patient/PrintPatientSideCard";

    const frc = Vue.prototype.$frc;

    export default {
        name: "AddNewPatient",
        components: {PrintPatientSideCard, Loading, ContentHeader, NewPatientMainCard, PatientSideCard},
        props: ['ftitle'],
        data: function() {
            return {
                displayLoading: true,
                openNewPatientCard: false,
                searchValue: '',
                patients: [],
                openPatientCard: false,
                selectedPatient: {},
                selectedPatientStatus: undefined,
                showTable: false,
                searchError: false,
                selectedPatientDevice: null,
                openPrintCard: false
            }
        },
        mounted () {
            EventBus.$on("patientCalled", this.updateStatus);
            EventBus.$on("newPatientCreated", this.onNewPatientCreation);
        },
        beforeDestroy() {
            EventBus.$off("patientCalled", this.updateStatus);
            EventBus.$off("newPatientCreated", this.onNewPatientCreation);
        },
        computed: {
            isCardOpen() {
                return this.openPatientCard || this.openNewPatientCard || this.openPrintCard;
            },
            cls0() {
                return this.isCardOpen ? 'content-sidebar-header sidebars-50-50' : 'flow-margin-right';
            },
            cls1() {
                return this.isCardOpen ? 'w3-container content-sidebars sidebars-50-50' : 'w3-container flow-main-content';
            },
            cls2() {
                return this.isCardOpen ? 'zero w3-col content-sidebar-left' : 'zero w3-col w3-center';
            }
        },
        methods: {
            loggedIn(patient) {
                var res = Vue.getValueForKey(patient.properties.entry, 'device');
                return res;
            },
            updateStatus (patient) {
                this.selectedPatientStatus = patient.status;
                for (var i = 0; i < this.patients.length; i++) {
                    if (this.patients[i] && this.patients[i].id === patient.id) {
                        this.$set(this.patients, i, patient);
                        break;
                    }
                }
            },
            openNewPatient() {
                this.openNewPatientCard = true;
            },
            searchPatients () {
                var app = this;
                app.displayLoading = true;
                if (!app.searchValue.replace(/\s/g, '').length) {
                    this.searchError = true;
                    return;
                }
                var valueWithNoSpaces = app.searchValue.trim();
                frc.searchPatient(valueWithNoSpaces).then(function (res) {
                    app.patients = res.data;
                    app.showTable = true;
                    app.displayLoading = false;
                    app.searchError = false;
                }).catch(function (ex) {
                    console.log(ex)
                })
            },
            trim(name) {
                if (name && name.length > 30) {
                    return name.slice(0, 30) + "...";
                }

                return name;
            },
            patientSelected (patient) {
                this.closeAllCards();
                this.openPatientCard = true;
                this.selectedPatient = patient;
                this.selectedPatientDevice = Vue.getValueForKey(patient.properties.entry, 'device');
            },
            onNewPatientCreation(patientId) {
                var route = "/patients/" + patientId;
                this.$router.push(route);
            },
            patientToPrintSelected(patient) {
                this.closeAllCards();
                this.openPrintCard = true;
                this.selectedPatient = patient;
            },
            closeAllCards() {
                this.openPatientCard = false;
                this.openPrintCard = false;
                this.openNewPatientCard = false;
            }
        }
    }

</script>

<style scoped>

</style>